// removed by extract-text-webpack-plugin
module.exports = {"base":"BattlesNotHeldMessage_base--jdA8H","highlightedText":"BattlesNotHeldMessage_highlightedText--sryyB"};


//////////////////
// WEBPACK FOOTER
// ./containers/BattleRooms/components/BattleRoomsSchedule/components/BattlesNotHeldMessage/BattlesNotHeldMessage.scss
// module id = 439
// module chunks = 11 12